/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(entityId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetExternalLocationsByEntity: {
        $xmlns: 'http://dobs.pa.gov/dp/location/bpm/1.0',
        EntityID: entityId
      }
    },
    blueprintArrays: ['GetExternalLocationsByEntityResponse.Locations.DP_EntityLocation'],
    blueprint: {
      Locations: [
        '$..DP_EntityLocation',
        {
          id: '$.ID',
          entityId: '$.EntityID',
          addressID: '$.AddressID',
          addressLine1: '$.AddressLine1',
          addressLine2: '$.AddressLine2 ',
          county: '$.County',
          city: '$.City',
          state: '$.State',
          postalCode: '$.PostalCode',
          country: '$.Country',
          officeType: '$.OfficeType'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      _.each(response.Locations, function(Location) {
        Location.officeType = Location.officeType ? Location.officeType : '--';
        Location.postalCode = Location.postalCode ? Location.postalCode : '--';
        Location.city = Location.city ? Location.city : '--';
        Location.addressLine1 = Location.addressLine1 ? Location.addressLine1 : '--';
        Location.state = Location.state ? Location.state : '--';
      });

      defer.resolve(response.Locations);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
